function openLevel(evt, levelName) {
  var i, tabcontent, tablinks;
  tabcontent = document.getElementsByClassName("tabcontent");
  for (i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.display = "none";
  }
  tablinks = document.getElementsByClassName("tablinks");
  for (i = 0; i < tablinks.length; i++) {
    tablinks[i].className = tablinks[i].className.replace(" active", "");
  }
  document.getElementById(levelName).style.display = "block";
  evt.currentTarget.className += " active";
}

document.querySelectorAll(".swell-faq-list li").forEach((item) => {
  item.addEventListener("click", function (e) {
    e.preventDefault();
    const explanation = this.querySelector(".swell-faq-explanation");
    const loadMore = this.querySelector(".swell-faq-load-more");

    explanation.classList.toggle("swell-faq-show");
    explanation.classList.toggle("swell-faq-hide");

    if (getComputedStyle(explanation).display === "none") {
      loadMore.textContent = "+";
    } else {
      loadMore.textContent = "-";
    }
  });
});

const carousel = document.getElementById("yotpo-mobile-carousel");
const images = carousel.getElementsByTagName("img");
const totalImages = images.length;
let currentIndex = 0;

function showImage(index) {
  const offset = -index * 50;
  for (let i = 0; i < totalImages; i++) {
    images[i].style.transform = `translateX(${offset}%)`;
  }
  currentIndex = index;
}

function nextImage() {
  const nextIndex = currentIndex + 2;
  if (nextIndex < totalImages) {
    showImage(nextIndex); // Display next two images
  }
}

function prevImage() {
  const prevIndex = currentIndex - 2;
  if (prevIndex >= 0) {
    showImage(prevIndex); // Display previous two images
  }
}
